module.exports = __webpack_public_path__ + "static/4-a4e427e97f0e9b62a1b839153c8a7c5b.png";